export const FEATURE_FLAG = {
  ADDRESS_GOOGLE_API: 'address_google_api',
  ACCOUNT_CREATION_FROM_CHECKOUT: 'account_creation_from_checkout',
  ADDRESS_SUGGESTION_JP: 'address_suggestion_jp',
  ADYEN_EU: 'adyen_eu',
  ADYEN_LEGAL_TERMS: 'adyen_legal_terms',
  ALGOLIA: 'algolia',
  AVOID_CONSENT_FOR_COOKIES: 'avoid_consent_for_cookies',
  BACK_IN_STOCK_WITH_COMMERCEAPI: 'back_in_stock_with_commerceapi',
  BACK_IN_STOCK_COMMERCEAPI_WITH_PHONE: 'back_in_stock_commerceapi_with_phone',
  BRAZE: 'braze',
  BAIDU: 'baidu',
  BATTERY_ECO_FEE: 'battery_eco_fee',
  BOBJ_REST: 'bobj_rest',
  BOUTIQUE_STOCK_AVAILABILITY: 'boutique_stock_availability',
  CARRIER_ADDRESS_VALIDATION: 'carrier_address_validation',
  CHECKOUT_INLINE_ADDRESS_FORM: 'checkout_inline_address_form',
  CHECKOUT_REVAMP_2025: 'checkout_revamp_2025',
  CONSENT_FOR_EXTERNAL_CONTENT: 'consent_for_external_content',
  DISABLE_FILTERS_NO_RESULTS: 'disable_filters_no_results',
  DISPLAY_CITES_LINK_ON_PRODUCT_PAGE: 'display_cites_link_on_product_page',
  HIDE_GIFT_WRAPPING_CHECKBOX: 'hide_gift_wrapping_checkbox',
  HIDE_GIFT_WRAPPING_FOR_CLOCKS: 'hide_gift_wrapping_for_clocks',
  DISPLAY_DISCLAIMER_PIN_CODE: 'display_disclaimer_pin_code_on_sign_up',
  DISPLAY_PAYMENT_TYPES_REASSURANCE_ON_CHECKOUT_PAGE: 'display_payment_types_reassurance_on_checkout_page',
  DISPLAY_PIPL_CBDT_CONSENT_CHECKBOX: 'display_pipl_cbdt_consent_checkbox',
  DISPLAY_PRICES: 'display_prices',
  ECOM: 'ecom',
  ENGRAVING: 'engraving',
  FORCE_RENDEZ_VOUS: 'force_rendez_vous',
  GEMINI_CN: 'gemini_cn',
  GEMINI_KR: 'gemini_kr',
  GEMINI_MEIA: 'gemini_meia',
  GEMINI_TW: 'gemini_tw',
  GUEST_ORDER_TOKEN_REQUEST: 'guest_order_token_request',
  HK_NEW_FORM: 'hk_new_form',
  HYDRA_SSO: 'hydra_sso',
  KOREAN_POST: 'korean_post',
  LIGHT_ECOM: 'light_ecom',
  LIMITED_EDITION_NUMBER: 'limited_edition_number',
  MY_ACCOUNT: 'my_account',
  NAVER_TRACKING: 'naver_tracking',
  NEWCOM_CHECKOUT: 'newcom_checkout',
  ONLINE_PAYMENT: 'online_payment',
  ORDER_CANCELLATION: 'order_cancellation',
  ORDER_REFUND_EXCHANGE: 'order_refund_exchange',
  PASSWORD_RULE_FEBRUARY_2025: 'password_rule_february_2025',
  PIA_2026_REVAMP: 'pia_2026_revamp',
  PLACES_AUTOCOMPLETE_API: 'places_autocomplete_api',
  RESTRICTED_MATERIALS: 'restricted_materials',
  STOCK_NOTIFICATION: 'stock_notification',
  SWSE_NEWSLETTER: 'swse_newsletter',
  WATCH_COMPARATOR: 'watch_comparator',
  WEBOUTIQUE_CTA_ON_PRODUCT_PAGE: 'weboutique_cta_on_product_page',
};

export function getFeatureFlag(name) {
  return !!window.Phoenix.featureFlags[name];
}
